import React from 'react';
import { Options } from 'nouislider';

import { Typography } from '../../common/Typography';
import { Slider, SliderProps } from '../Slider';
import { RemainSide, SellSide, Amount, ValuesDifference } from './styles';

export interface SliderInvestProps extends SliderProps {
  sellAmount?: string | React.ReactNode;
  sellQuantity?: string | React.ReactNode;
  remainAmount?: string | React.ReactNode;
  remainQuantity?: string | React.ReactNode;
  withModal?: boolean;
}

export const SliderInvest = (props: SliderInvestProps & Options) => {
  const { sellAmount, sellQuantity, remainAmount, remainQuantity } = props;
  let additionalParams;

  const stopEvent = (e: Event) => {
    e.stopPropagation();
  };

  if (props.withModal) {
    additionalParams = {
      onStart: () => {
        document.body.addEventListener('mouseup', stopEvent, true);
        document.body.addEventListener('click', stopEvent, true);
      },
      onEnd: () => {
        document.body.removeEventListener('click', stopEvent, true);
        document.body.removeEventListener('mouseup', stopEvent, true);
      }
    };
  }

  return (
    <Slider {...props} {...additionalParams}>
      <ValuesDifference>
        <SellSide>
          <Amount>{sellAmount}</Amount>
          <Typography.Text size="small" view="hint">
            {sellQuantity}
          </Typography.Text>
        </SellSide>
        <RemainSide>
          <Amount>{remainAmount}</Amount>
          <Typography.Text size="small" view="hint">
            {remainQuantity}
          </Typography.Text>
        </RemainSide>
      </ValuesDifference>
    </Slider>
  );
};
